import { IInterviewQuestionFormInput } from "../../Pages/InterviewQuestion/InterviewQuestion.model";
import { buildApiUrl } from "../../config/api";
import axiosInstance from "../axios/axiosInstance";

const API = buildApiUrl("/interviewQuestionApp/interview-questions/");

export const interviewQuestionService = {
  async getAll() {
    return axiosInstance.get(API);
  },
  async create(payload: IInterviewQuestionFormInput) {
    return axiosInstance.post(API, payload);
  },
  async update(id: number, data: IInterviewQuestionFormInput) {
    try {
      const res = await axiosInstance.put(`${API}${id}/`, data);
      return { success: true, data: res.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async remove(id: number) {
    try {
      const res = await axiosInstance.delete(`${API}${id}/`);
      return { success: true, data: res };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async getCountByTopic(topicId: number) {
    return axiosInstance.get(`${API}count-by-topic/`, { params: { topic_id: topicId } });
  },
};
